var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "lnb_container" }, [
    _c("a", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.rootMenu.menuId,
          expression: "rootMenu.menuId"
        }
      ],
      class: _vm.isFoldMenu ? "ico_collapsed_right" : "ico_collapsed",
      attrs: {
        href: "javascript:",
        "data-trigger-resize": "",
        "data-toggle-state": "ui---lnb-collapsed",
        title: _vm.isFoldMenu
          ? _vm.$t("cop.common.main-side.expand")
          : _vm.$t("cop.common.main-side.fold")
      },
      on: {
        click: function($event) {
          return _vm.toggleIsFoldMenu()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "ui--lnb-inner" }, [
      _c("div", { staticClass: "ui--nav-heading" }, [
        _vm._v(_vm._s(_vm.getLabel(_vm.rootMenu)))
      ]),
      _vm._v(" "),
      _c("nav", { staticClass: "ui--sidebar" }, [
        _c(
          "ul",
          { staticClass: "ui--sidebar-nav" },
          _vm._l(_vm.groupMenus, function(menu) {
            return _c(
              "li",
              {
                key: menu.menuId,
                class: { active: _vm.selGroupId === menu.menuId }
              },
              [
                _c("strong", [
                  menu.externalUrlUsed === true
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.openExternalUrl(menu.externalUrl)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(menu)))])]
                      )
                    : menu.defaultPage
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.moveMenu(menu.defaultPage.pagePath)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(menu)))])]
                      )
                    : _c(
                        "a",
                        {
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.groupSelect(menu)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(menu)))])]
                      ),
                  _vm._v(" "),
                  _vm.getSubMenus(menu.menuId).length !== 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn ui--btn-sidebar",
                          attrs: {
                            title:
                              _vm.selGroupId === menu.menuId
                                ? _vm.$t("cop.common.main-side.fold")
                                : _vm.$t("cop.common.main-side.expand")
                          },
                          on: {
                            click: function($event) {
                              return _vm.groupSelect(menu)
                            }
                          }
                        },
                        [
                          _c("em", {
                            class: {
                              "icon-arrow-up": _vm.selGroupId === menu.menuId,
                              "icon-arrow-down": _vm.selGroupId !== menu.menuId
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.getSubMenus(menu.menuId).length !== 0
                  ? _c(
                      "ul",
                      {
                        staticClass:
                          "colapse ui--sidebar-nav ui--sidebar-subnav",
                        class: { show: _vm.selGroupId === menu.menuId }
                      },
                      _vm._l(_vm.getSubMenus(menu.menuId), function(subMenu) {
                        return _c(
                          "li",
                          {
                            key: subMenu.menuId,
                            class: { active: _vm.selMenuId === subMenu.menuId },
                            on: {
                              click: function($event) {
                                subMenu.externalUrlUsed === true
                                  ? _vm.openExternalUrl(subMenu.externalUrl)
                                  : _vm.moveMenu(subMenu.menuUrl)
                              }
                            }
                          },
                          [
                            _c("a", { attrs: { href: "javascript:" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.getLabel(subMenu)) +
                                  "\n                "
                              ),
                              subMenu.externalUrlUsed === true
                                ? _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons ui--menu-icon-3"
                                    },
                                    [_vm._v("open_in_new")]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "download_wrap" },
        [
          _vm.downloadMenu === "RESOURCE"
            ? [
                _c(
                  "button",
                  {
                    class:
                      "btn btn_client_download " +
                      (_vm.downloadFlag ? "on" : ""),
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.downloadFlag = !_vm.downloadFlag
                      }
                    }
                  },
                  [_vm._v("\n          Web Client Download\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.downloadFlag,
                        expression: "downloadFlag"
                      }
                    ],
                    staticClass: "download_list"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked window",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.webClientDownload("WINDOWS")
                          }
                        }
                      },
                      [_vm._v("Windows")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked linux",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.webClientDownload("LINUX")
                          }
                        }
                      },
                      [_vm._v("Linux")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked macos",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.webClientDownload("MACOS")
                          }
                        }
                      },
                      [_vm._v("Mac OS")]
                    )
                  ]
                )
              ]
            : _vm.downloadMenu === "CONSOLE"
            ? [
                _c(
                  "button",
                  {
                    class:
                      "btn btn_client_download bg_none " +
                      (_vm.downloadFlag ? "on" : ""),
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.downloadFlag = !_vm.downloadFlag
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("cop.home.label.mycsp.cspLogin")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.downloadFlag,
                        expression: "downloadFlag"
                      }
                    ],
                    staticClass: "download_list"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked aws",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.downloadAWSCLIScript()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cop.coa.cli.label.downloadAWSCLIScript")
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked aws",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.downloadAWSChinaCLIScript()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "cop.coa.cli.label.downloadAWSChinaCLIScript"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked spc",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.downloadSPCCLIScript()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("cop.coa.cli.label.downloadSPCCLIScript")
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked aws",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("AWS")
                            _vm.openCloudUrl("aws")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.awsConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showDefaultRole
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn_down_linked aws",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.defaultAWSPopup("aws")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("cop.home.label.mycsp.awsDefaultRole")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked azure",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("Azure")
                            _vm.openCloudUrl("azure")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.azureConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked gcp",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("GCP")
                            _vm.openCloudUrl("gcp")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.gcpConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked oci",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("OCI")
                            _vm.openCloudUrl("oci")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.ociConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked ncp",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.ncpPopup()
                          }
                        }
                      },
                      [_vm._v("Naver Console")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked ali",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("ALI")
                            _vm.openCloudUrl("ali")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.aliConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked ali",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("ALI_CN")
                            _vm.openCloudUrl("ali_cn")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.alicnConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked scp",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("SCP")
                            _vm.openCloudUrl("scp")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.scpConsoleV1"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked aws",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("AWS_CN")
                            _vm.openCloudUrl("aws_cn")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.awscnConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showDefaultRole
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn_down_linked aws",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.defaultAWSPopup("aws_cn")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("cop.home.label.mycsp.awscnDefaultRole")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked spc",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("SPC")
                            _vm.openCloudUrl("spc")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.spcConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked azure",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("Azure_China")
                            _vm.openCloudUrl("azure_cn")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.azureCnConsole"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn_down_linked castAi",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.insertCoaLog("CAST_AI")
                            _vm.openCloudUrl("cast_ai")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("cop.home.label.mycsp.castAiConsole"))
                        )
                      ]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37af296a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37af296a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainSideMenu.vue
// module id = null
// module chunks = 